import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PATIENTS_CREATE } from "../constants/api";
import { apiUtils, auth } from "../utils";
import PatientForm from "./PatientForm";
import type { PatientFormPayload } from "./PatientForm";

export default function AddPatient() {
  const navigate = useNavigate();

  const handleSubmit = async (payload: PatientFormPayload) => {
    const hospitalId = auth.getUserId();
    const body = {
      ...payload,
      ...(hospitalId && { hospital_id: hospitalId }),
    };
    const response = await fetch(
      PATIENTS_CREATE,
      apiUtils.createRequestOptions("POST", body)
    );
    await apiUtils.handleResponse(response);
    navigate("/");
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="mx-auto px-3 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8 max-w-2xl">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="flex min-h-11 items-center gap-2 text-gray-700 hover:text-gray-900 mb-4 sm:mb-6 p-2 -ml-2 rounded-lg hover:bg-gray-200 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          <span className="text-sm font-medium">Back to Home</span>
        </button>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="px-4 py-4 sm:px-6 border-b border-gray-200">
            <h1 className="text-xl font-semibold text-gray-900">
              Add New Patient
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              Enter basic and physical details.
            </p>
          </div>

          <PatientForm
            mode="add"
            onSubmit={handleSubmit}
            onCancel={() => navigate("/")}
          />
        </div>
      </div>
    </div>
  );
}
